<template>
  <v-simple-table class="itemTable">
    <template v-slot:default>
      <thead>
      <tr class="ItemHead">
        <th class="text-left">รายการ</th>
        <th class="text-right">แต้ม/หน่วย</th>
        <th class="text-right">จน.</th>
        <th class="text-right">รวมแต้ม</th>
      </tr>
      </thead>
      <tbody v-if="order.items">

      <tr v-for="(item, index) in order.items.filter(i => i.is_start_of_promotion!==false)"
          :key="index"
          :currentIndex="index"
          class="ItemRow"
      >
        <!-- PRODUCT -->
        <td v-if="item.is_start_of_promotion && [null,'S'].includes(item.promotion_type) && item.promotion && item.promotion.promotion_type==='D'"
            colspan="2">
          โปรฯ: {{ item.promotion.name }}<br/>

          <span style="float: right">
            <v-icon x-small color="orange">mdi-star</v-icon>
            {{ $helper.number_format(item.point_final || 0, 2, 2) }}
          </span>
          {{ item.index_no }}.) {{ (item.product ? item.product.nickname : null) || item.product_code }}
          <StatusBadge :item="item" :order="order"></StatusBadge>


          <div v-for="relate_item  in item.promotion_pack">

            {{ relate_item.index_no }}.) {{
              (relate_item.product ? relate_item.product.nickname : null) ||
              relate_item.product_code
            }}
            <span style="float: right">
              <v-icon x-small color="orange">mdi-star</v-icon>
              {{ $helper.number_format(item.point_final || 0, 2, 2) }}
            </span>


            <StatusBadge :item="item" :order="order"></StatusBadge>
          </div>


        </td>
        <td v-else-if="item.is_start_of_promotion && [null,'S'].includes(item.promotion_type)" colspan="2">
          โปรฯ: {{ item.promotion.name }} <br/>

          <span style="float: right">
            <v-icon x-small color="orange">mdi-star</v-icon>
            {{ $helper.number_format(item.point_final || 0, 2, 2) }} x {{ item.promotion_qty }} = {{ item.quantity }}
          </span>
          {{ item.index_no }}.) {{ (item.product ? item.product.nickname : null) || item.product_code }}
          <StatusBadge :item="item" :order="order"></StatusBadge>


          <div v-for="relate_item  in item.promotion_pack">
            <span style="float: right">
              <v-icon x-small color="orange">mdi-star</v-icon>
              {{ $helper.number_format(relate_item.point_final || 0, 2, 2) }} x {{ relate_item.promotion_qty }} = {{ relate_item.quantity }}
            </span>
            {{ relate_item.index_no }}.) {{
              (relate_item.product ? relate_item.product.nickname : null) ||
              relate_item.product_code
            }}


            <StatusBadge :item="item" :order="order"></StatusBadge>
          </div>


        </td>
        <td v-else>
          <span v-if="item.promotion">โปรฯ: {{ item.promotion.name }}<br/></span>


          {{ item.index_no }}.) {{
            (item.product ? item.product.nickname : null) || item.product_code
          }}
          <v-btn
              v-if="order.status < OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO  && item.product && order.custom && order.custom.check && order.custom.check.stock && order.custom.check.stock[item.product_code]"
              class="ml-1 grey darken-2 pa-1 caption"
              style="color: white" x-small>
            คลังเหลือแค่ {{ $helper.number_format(item.product.stock_MT * item.product.unit_prim_rate) }}
            {{ $helper.parseUnit(item.unit) }}
            <span
                v-if="item.product.reserve_MT-item.quantity>0">จองแล้ว {{
                $helper.number_format(item.product.reserve_MT - item.quantity)
              }}  {{ $helper.parseUnit(item.unit) }}</span>
          </v-btn>

          <v-btn
              v-if="item.product?.non_over_stock"
              class="ml-1 orange pa-1 caption"
              style="color: white" x-small>
            !! สินค้าไม่ผลิตเพิ่ม
          </v-btn>

          <v-btn
              v-if="order.status >= OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM && item.product && item.product.weight === 0"
              class="ml-1 red pa-1 caption"
              style="color: white" x-small>
            !! สินค้าไม่มีน้าหนัก
          </v-btn>
          <v-btn
              v-if="order.status >= OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM && item.product && item.product.volume === 0"
              class="ml-1 red pa-1 caption"
              style="color: white" x-small>
            !! สินค้าไม่มี cbm
          </v-btn>


          <StatusBadge :item="item" :order="order"></StatusBadge>


        </td>


        <!-- POINT FINAL -->
        <td v-if="item.promotion_id===null || ['T','D','F'].includes(item.promotion_type?item.promotion_type:'')"
            class="text-right">
          <v-icon x-small color="orange">mdi-star</v-icon>
          {{ $helper.number_format(item.point_final || 0, 2, 2) }}
        </td>

        <!-- QUANTITY -->

        <td v-if="item.promotion_id && [null,'S'].includes(item.promotion_type) && item.promotion && item.promotion.promotion_type==='D'"
            class="text-right item-qty">
          <br/>
          {{ $helper.number_format(item.quantity) }} {{ $helper.parseUnit(item.unit) }}
          <div v-for="relate_item  in item.promotion_pack">
            {{ $helper.number_format(relate_item.quantity) }} {{ $helper.parseUnit(relate_item.unit) }}
          </div>

        </td>
        <td v-else-if="item.promotion_id && [null,'S'].includes(item.promotion_type)"
            class="text-right item-qty">
          {{ $helper.number_format(item.quantity / item.promotion_qty) }}
          ชุด
        </td>
        <td v-else class="text-right item-qty">{{ $helper.number_format(item.quantity) }}
          {{ $helper.parseUnit(item.unit) }}
        </td>

        <!-- TOTAL POINT -->
        <td v-if="item.is_start_of_promotion && [null,'S'].includes(item.promotion_type) && item.promotion && item.promotion.promotion_type==='D'"
            class="text-right">
          <br/>
          <v-icon x-small color="orange">mdi-star</v-icon>
          {{ $helper.number_format(item.total_point || 0, 2, 2) }}
          <div v-for="relate_item  in item.promotion_pack">
            <v-icon x-small color="orange">mdi-star</v-icon>
            {{ $helper.number_format(relate_item.total_point || 0, 2, 2) }}
          </div>

        </td>
        <td v-else-if="item.is_start_of_promotion && [null,'S'].includes(item.promotion_type)"
            class="text-right">
          <v-icon x-small color="orange">mdi-star</v-icon>
          {{ $helper.number_format(item.total_point || 0, 2, 2) }}
        </td>
        <td v-else class="text-right">
          <v-icon x-small color="orange">mdi-star</v-icon>
          {{ $helper.number_format(item.total_point || 0, 2, 2) }}
        </td>


      </tr>


      <tr v-if="order.dynamicPromotionItems && order.dynamicPromotionItems.length>0">
        <td colspan="4" style="height: 20px;color: darkorange">
          โปรโมชั่น
        </td>
      </tr>
      <tr v-for="(item, index) in order.dynamicPromotionItems"
          :key="'d'+index"
          :currentIndex="index"
          :item="item"
          :items="order.dynamicPromotionItems"
          class="ItemRow"
      >
        <!-- NAME -->
        <td>
          <div>
            <div v-if="item.is_start_of_promotion">
              {{
                (item.product ? item.product.nickname : null) ||
                item.product_code
              }}
            </div>
            <div v-else>
              └ {{
                (item.product ? item.product.nickname : null) ||
                item.product_code
              }}
            </div>

          </div>
        </td>

        <td></td>
        <!-- QTY -->
        <td class="text-right">

          <span class="stock-md">
            {{ $helper.number_format(item.quantity) }} <span
              style="font-size: 0.7em;font-weight:normal;">{{ $helper.parseUnit(item.unit) }}</span>
          </span>

        </td>

        <!-- TOTAL POINT -->
        <td class="text-right">
          <v-icon x-small color="orange">mdi-star</v-icon>
          {{ $helper.number_format(item.total_point || 0, 2, 2) }}
        </td>
      </tr>


      </tbody>

      <tbody
          v-if="order.status===OrderConst.STATUS_CART && order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE">

      <tr v-if="order.dynamicPromotionItems && order.dynamicPromotionItems.length>0">
        <td colspan="4" style="height: 20px;color: darkorange">
          โปรโมชั่น
        </td>
      </tr>
      <tr v-for="(item, index) in order.dynamicPromotionItems"
          :key="'d'+index"
          :currentIndex="index"
          :item="item"
          :items="order.dynamicPromotionItems"
          class="ItemRow"
      >
        <!-- NAME -->
        <td class="d-none d-md-table-cell" colspan="2">
          {{ item.promotion.name }}
          {{
            (item.product ? item.product.nickname : null) ||
            item.product_code
          }}
        </td>


        <!-- QTY -->
        <td class="text-right item-qty">

          <span class="stock-md">
            {{ $helper.number_format(item.quantity) }} <span
              style="font-size: 0.7em;font-weight:normal;">{{ $helper.parseUnit(item.unit) }}</span>
          </span>

        </td>

        <!-- TOTAL POINT -->
        <td class="text-right" @click="onClickPromotion(item)">
          <span>
            <v-icon x-small color="orange">mdi-star</v-icon>
            {{ $helper.number_format(item.total_point || 0, 2, 2) }}
          </span>
        </td>
      </tr>


      </tbody>

    </template>
  </v-simple-table>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator'
import {Order, OrderConst} from '@/models/Order'
import StatusBadge from '@/components/Order/StatusBadge.vue'

@Component({
  components: {StatusBadge}
})
export default class OrderDialogTablePoint extends Vue {
  @Prop() order!: Order
  OrderConst = OrderConst

  onClickPromotion(item: any) {
    this.$emit('click-promotion', item)
  }
}
</script>
